import { UseQueryResult, useQuery } from 'react-query'

import { QueryKey } from '@/configs/queryKeys'
import { getFeatureFlag } from '@/services/feature-flag'

interface IFeatureFlag {
  erros: string[]
  sucesso: boolean
  conteudo: {
    idEmpregador: string
    featureFlag: string
  }
}

export function useGetFeatureFlagData({
  employerId,
  featureFlag,
}: {
  employerId: string
  featureFlag: string
}): UseQueryResult<IFeatureFlag> {
  return useQuery(
    [QueryKey.featureFlag, { params: { employerId, featureFlag } }],
    getFeatureFlag,
    {
      staleTime: 1000 * 60 * 60 * 24, // 1 day,
      keepPreviousData: true,
      cacheTime: 10 * (60 * 1000), // 10 mins
      retry: false,
      refetchOnReconnect: false,
      enabled: !!employerId
    }
  )
}
